import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PropTypes} from "prop-types";

import JournalFacet from "../../../components/journal/front/list/facet";
import JournalItem from "../../../components/journal/front/list/Jitem";
import JournalOrder from "../../../components/journal/front/list/order";
import FrontFooter from '../../../components/etc/footer/';

import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/journals";

import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import {BASE_PATH} from "../../../wpconfig";

class Journals extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'journals'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		if (location.search.substring(1)) {
			this.props.dataActions.setJournals({'param': func.parseParams(location.search.substring(1))});
		} else {
			this.facetReset()
		}
		// 이해 안됨.
		setTimeout(() => {
			this.getList();
		}, 0);
	}

	componentWillUnmount(){
		this.setState = (state, callback) => {
			return;
		}
	}

	facetReset() {
		let param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'record_per_page' || key === 'order' || key === 'order_by') {
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		const {dataActions} = this.props;
		dataActions.setJournals({"param": param});
	}

	getList() {
		func.getData(this.state.action, this.props.param).then((response) => {
			this.setState({
				isInit: true,
			})
			this.props.dataActions.setJournals(response);
		});
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.props.param;
		param['current_page'] = paged;

		const {dataActions} = this.props;
		dataActions.setJournals({"param": param});

		setTimeout(() => {
			func.getData(this.state.action, this.props.param).then((response) => {
				this.props.dataActions.setJournals(response);

				const url = objectToQueryString(this.props.param);
				pushUrl('검색', BASE_PATH + this.state.action +'/?' + url, this.props.param);

				func.scrollMove();
			});
		}, 0);
	}

	render() {
		const {records} = this.props;
		const {isInit} = this.state;
		const {setDetail} = this;

		return (
			<div className="contents-group">
				<JournalFacet/>
				<div className="center-group">
					{!isInit && <Loading/>}
					{(isInit && records.length <= 0) &&
					<div className="search-none">
						<div className="icon icon-search-none"/>
						<div className="desc">검색 결과가 없습니다.</div>
					</div>
					}
					{(isInit && records.length > 0) &&
						<div className="">
							<div className="d-flex justify-content-between align-items-center">
								<JournalOrder/>
							</div>
							<>
								<div className="mt-3">
									<div>
										<div className="line-list-group">
											{records.map((record, index) => {
												return (
													<JournalItem key={index} pSetDetail={setDetail} record={record}/>
												)
											})}
										</div>
									</div>
								</div>
								{this.props.totalPage > 1 &&
								<div className="mt-4">
									<div>
										<div className="paging-wrap">
											<ReactPaginate
												forcePage={Number(this.props.param.current_page) - 1}
												pageCount={this.props.totalPage}
												marginPagesDisplayed={2}
												pageRangeDisplayed={10}
												onPageChange={this.handlePageClick}
												containerClassName={'pagination'}
												activeClassName={'active'}
												pageClassName={'page-item'}
												pageLinkClassName={'page-link'}
												previousClassName={'page-item page-item-prev'}
												previousLinkClassName={'page-link'}
												nextClassName={'page-item page-item-next'}
												nextLinkClassName={'page-link'}
											/>
										</div>
									</div>
								</div>
								}
							</>
						</div>
					}
				</div>
				<FrontFooter
					param={this.props.param}
					facet={this.props.facet}
					dataActions={this.props.dataActions} />
			</div>
		)
	}
}

export default connect(
	(state) => ({
		param: state.journals.param ? state.journals.param : {},
		records: state.journals.records ? state.journals.records : [],
		facet: state.journals.facet ? state.journals.facet : {},
		totalRecords: state.journals.totalRecords ? state.journals.totalRecords : 0,
		totalPage: state.journals.totalPage ? state.journals.totalPage : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		// fDataActions: bindActionCreators(FActions, dispatch),
	}),
)(Journals)

Journals.propTypes = {
	param: PropTypes.object,
	records: PropTypes.array,
	facet: PropTypes.object,
	totalRecords: PropTypes.number,
	totalPage: PropTypes.number,
};
